/* =============================================================
   Sound Brothers — Scroll-Pfeile für alle horizontalen Slider
   Runde, schwebende Pfeile links/rechts über den frei scrollbaren
   Bereichen. Blenden sich aus, wenn es in die Richtung nichts
   mehr zu scrollen gibt. Nur auf Geräten mit Maus/Trackpad —
   am Touchscreen bleibt das native Wischen ohne Überlagerung.
   ============================================================= */
(function () {
  var SELEKTOREN = [
    '.sb-pscroll',
    '.sb-ref__scroller',
    '.sb-references__scroller',
    '.sb-quickaccess__scroller',
    '.sb-team--slider .sb-team__slider',
    '.sb-loesungen--slider .sb-loesungen__slider',
    '.sb-category-tiles--slider .sb-category-tiles__slider'
  ].join(',');

  var PFEIL = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setup(scroller) {
    if (scroller.dataset.sbArrows) return;
    scroller.dataset.sbArrows = '1';

    // Wrapper, damit die Pfeil-Leiste unter den Scroller rutschen kann,
    // ohne dessen Layout (Full-Bleed-Margins etc.) zu verändern.
    var huelle = document.createElement('div');
    huelle.className = 'sb-arrows';
    scroller.parentNode.insertBefore(huelle, scroller);
    huelle.appendChild(scroller);

    // Mittige Leiste UNTER dem Scroller
    var leiste = document.createElement('div');
    leiste.className = 'sb-arrows__leiste';
    huelle.appendChild(leiste);

    function baueKnopf(richtung) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sb-arrows__btn sb-arrows__btn--' + richtung;
      b.setAttribute('aria-label', richtung === 'prev' ? 'Zurück scrollen' : 'Weiter scrollen');
      b.innerHTML = PFEIL;
      b.addEventListener('click', function () {
        var schritt = Math.max(scroller.clientWidth * 0.8, 260);
        scroller.scrollBy({ left: richtung === 'prev' ? -schritt : schritt, behavior: 'smooth' });
      });
      leiste.appendChild(b);
      return b;
    }
    var zurueck = baueKnopf('prev');
    var weiter = baueKnopf('next');

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      var x = scroller.scrollLeft;
      huelle.classList.toggle('sb-arrows--idle', max <= 4);
      zurueck.classList.toggle('sb-arrows__btn--aus', x <= 4);
      weiter.classList.toggle('sb-arrows__btn--aus', x >= max - 4);
    }
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(scroller);
    update();
  }

  function scan(root) {
    (root || document).querySelectorAll(SELEKTOREN).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
